import * as z from "zod";

import { OnlineStoreHostnameSchema, ShopifyCanonicalDomainSchema } from "./shopify-shop";

export const ShopifyProxyPayloadSchema = z.strictObject({
  domain: ShopifyCanonicalDomainSchema,
  onlineStoreDomain: OnlineStoreHostnameSchema,
  storefrontAccessToken: z
    .string()
    .min(1)
    .max(512)
    .regex(/^[\x21-\x7e]+$/),
  shopUrl: z
    .url({ protocol: /^https?$/ })
    .max(2048)
    .pipe(
      z.string().refine((value) => {
        const url = new URL(value);
        return !url.username && !url.password;
      }),
    ),
});
export type ShopifyProxyPayload = z.infer<typeof ShopifyProxyPayloadSchema>;

export const ShopifyProxyTokenSchema = z
  .string()
  .max(3800)
  .regex(/^v1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/);
